import React from 'react';
import { Route } from 'react-router-dom';

import ProaqDestaques from '../../ProcessosAquisitivos/ProaqDestaques';
import ProaqFicha from '../../ProcessosAquisitivos/ProcessosLicitatorios/Ficha/Index';
import ProaqIndex from '../../ProcessosAquisitivos/ProcessosLicitatorios/Index';
import ActsDestaque from '../../ProcessosAquisitivos/acts/ActsDestaque';
import ActsFicha from '../../ProcessosAquisitivos/acts/ActsFicha';
import ActsIndex from '../../ProcessosAquisitivos/acts/ActsIndex';
import ArpsDestaques from '../../ProcessosAquisitivos/arps/ArpsDestaques';
import ArpsFicha from '../../ProcessosAquisitivos/arps/ArpsFicha';
import ContratosArpsIndex from '../../ProcessosAquisitivos/arps/ArpsIndex';
import ContratosDestaque from '../../ProcessosAquisitivos/contratos/ContratosDestaque';
import ContratosEntregas from '../../ProcessosAquisitivos/contratos/ContratosEntregas';
import ContratosFicha from '../../ProcessosAquisitivos/contratos/ContratosFicha';
import ContratosIndex from '../../ProcessosAquisitivos/contratos/ContratosIndex';
import ContratosPautas from '../../ProcessosAquisitivos/contratos/ContratosPautas';
import EmpenhosDestaque from '../../ProcessosAquisitivos/empenhos/EmpenhosDestaque';
import EmpenhosFicha from '../../ProcessosAquisitivos/empenhos/EmpenhosFicha';
import ContratosEmpenhosIndex from '../../ProcessosAquisitivos/empenhos/EmpenhosIndex';
import ListagemAquisicoesIndex from '../../ProcessosAquisitivos/listagemAquisicoes/ListagemAquisicoesIndex';
import OrgIntersDadosGerais from '../../ProcessosAquisitivos/orgInters/dadosGerais';
import OrgIntersDestaques from '../../ProcessosAquisitivos/orgInters/destaque';
import OrgIntersListagem from '../../ProcessosAquisitivos/orgInters/listagem';
import TedsDestaque from '../../ProcessosAquisitivos/teds/TedsDestaque';
import TedsEntregas from '../../ProcessosAquisitivos/teds/TedsEntregas';
import TedsFicha from '../../ProcessosAquisitivos/teds/TedsFicha';
import TedsIndex from '../../ProcessosAquisitivos/teds/TedsIndex';
import TedsPautas from '../../ProcessosAquisitivos/teds/TedsPautas';

const ProcessosAquisitivosRoutes = () => {
  return (
    <>
      {/* Listagem geral de Aquisições */}
      <Route path="proaq/aquisicoes" element={<ListagemAquisicoesIndex />} />

      {/* Processos Licitatórios */}
      <Route path="proaq/processos" element={<ProaqIndex />} />
      <Route path="proaq/processos/destaques" element={<ProaqDestaques />} />
      <Route
        path="proaq/processos/:id/destaques"
        element={<ProaqDestaques />}
      />
      <Route path="proaq/processos/dadosgerais" element={<ProaqFicha />} />
      <Route path="proaq/processos/:id/dadosgerais" element={<ProaqFicha />} />

      {/* ARPs */}
      <Route path="proaq/arps" element={<ContratosArpsIndex />} />
      <Route path="proaq/arps/dadosgerais" element={<ArpsFicha />} />
      <Route path="proaq/arps/:id/dadosgerais" element={<ArpsFicha />} />
      <Route path="proaq/arps/destaques" element={<ArpsDestaques />} />
      <Route path="proaq/arps/:id/destaques" element={<ArpsDestaques />} />

      {/* Contratos */}
      <Route path="proaq/contratos" element={<ContratosIndex />} />
      <Route path="proaq/contratos/dadosgerais" element={<ContratosFicha />} />
      <Route
        path="proaq/contratos/:id/dadosgerais"
        element={<ContratosFicha />}
      />
      <Route path="proaq/contratos/destaques" element={<ContratosDestaque />} />
      <Route
        path="proaq/contratos/:id/destaques"
        element={<ContratosDestaque />}
      />
      <Route path="proaq/contratos/pautas" element={<ContratosPautas />} />
      <Route path="proaq/contratos/:id/pautas" element={<ContratosPautas />} />
      <Route path="proaq/contratos/entregas" element={<ContratosEntregas />} />
      <Route
        path="proaq/contratos/ficha/:id/entregas"
        element={<ContratosEntregas />}
      />

      {/* TEDs */}
      <Route path="proaq/teds" element={<TedsIndex />} />
      <Route path="proaq/teds/dadosgerais" element={<TedsFicha />} />
      <Route path="proaq/teds/:id/dadosgerais" element={<TedsFicha />} />
      <Route path="proaq/teds/destaques" element={<TedsDestaque />} />
      <Route path="proaq/teds/:id/destaques" element={<TedsDestaque />} />
      <Route path="proaq/teds/pautas" element={<TedsPautas />} />
      <Route path="proaq/teds/:id/pautas" element={<TedsPautas />} />
      <Route path="proaq/teds/entregas" element={<TedsEntregas />} />
      <Route path="proaq/teds/:id/entregas" element={<TedsEntregas />} />

      {/* ACTs */}
      <Route path="proaq/acts" element={<ActsIndex />} />
      <Route path="proaq/acts/dadosgerais" element={<ActsFicha />} />
      <Route path="proaq/acts/:id/dadosgerais" element={<ActsFicha />} />
      <Route path="proaq/acts/destaques" element={<ActsDestaque />} />
      <Route path="proaq/acts/:id/destaques" element={<ActsDestaque />} />

      {/* Organismos Internacionais */}
      <Route path="proaq/orginters" element={<OrgIntersListagem />} />
      <Route
        path="proaq/orginters/dadosgerais"
        element={<OrgIntersDadosGerais />}
      />
      <Route
        path="proaq/orginters/:id/dadosgerais"
        element={<OrgIntersDadosGerais />}
      />
      <Route
        path="proaq/orginters/:id/destaques"
        element={<OrgIntersDestaques />}
      />

      {/* Empenhos */}
      <Route path="proaq/empenhos" element={<ContratosEmpenhosIndex />} />
      <Route path="proaq/empenhos/dadosgerais" element={<EmpenhosFicha />} />
      <Route
        path="proaq/empenhos/:id/dadosgerais"
        element={<EmpenhosFicha />}
      />
      <Route path="proaq/empenhos/destaques" element={<EmpenhosDestaque />} />
      <Route
        path="proaq/empenhos/:id/destaques"
        element={<EmpenhosDestaque />}
      />
    </>
  );
};

export default ProcessosAquisitivosRoutes;
